import { analytics, Enforce2FaEvents } from '@/lib/analytics'

interface Enforce2FaEventData {
  currentPlan: string
}

export function trackEnforce2FaModalViewed(data: Enforce2FaEventData): void {
  analytics.track(Enforce2FaEvents.MODAL_VIEWED, {
    current_plan: data.currentPlan,
  })
}

export function trackEnforce2FaContinueClicked(
  data: Enforce2FaEventData,
): void {
  analytics.track(Enforce2FaEvents.CONTINUE_CLICKED, {
    current_plan: data.currentPlan,
  })
}

export function trackEnforce2FaLogoutClicked(data: Enforce2FaEventData): void {
  analytics.track(Enforce2FaEvents.LOGOUT_CLICKED, {
    current_plan: data.currentPlan,
  })
}

export function trackEnforce2FaSetupCompleted(data: Enforce2FaEventData): void {
  analytics.track(Enforce2FaEvents.SETUP_COMPLETED, {
    current_plan: data.currentPlan,
  })
}
